import { render } from "./SplitTemplate.vue?vue&type=template&id=645918a8&scoped=true"
import script from "./SplitTemplate.vue?vue&type=script&lang=js"
export * from "./SplitTemplate.vue?vue&type=script&lang=js"

import "./SplitTemplate.vue?vue&type=style&index=0&id=645918a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645918a8"]])

export default __exports__